export default {
  headerContent: {
    title: 'Türkiye Sigorta Ferdi Kaza Sigortası Fiyatları',
    slogan: "Ferdi Kaza Sigortası'nı işin uzmanına bırak.",
    btnTitle: 'FERDİ KAZA SİGORTASI TEKLİFİ AL'
  },
  crossPageContent: {
    mainTitle: 'Türkiye Sigorta Ferdi Kaza Sigortası',
    description: {
      title: 'Türkiye Sigorta Ferdi Kaza Sigortası Nedir? ',
      content: [
        'pek çok duruma karşılık teminat alabilirsiniz. Çünkü kazaların nerede ve nasıl olacağı hiç belli olmadığından, başınıza bir kaza gelmesi durumunda maddi açıdan büyük zorluklar yaşayabilirsiniz.',
        'Kazalar her an her yerde gerçekleşebilir ve bu durumlara karşı alınmayan önlemler ciddi ekonomik sorunlar yaratabilir. Çünkü bu kaza hiç beklenmedik bir anda gerçekleşmiştir ve kazanın ön görülemez olması başta maddi sorunlar olmak üzere pek çok soruna yol açabilir. Böylece <strong>Türkiye Sigorta ferdi kaza sigortası</strong> söz konusu kaza durumlarına karşı güvence sunarak, sigortalı kişinin olası durumlardaki masraflarını karşılamaktadır.'
      ]
    },
    subContent: {
      title: 'Türkiye Sigorta Ferdi Kaza Sigortası Neleri Kapsar?',
      content: [
        {
          paragraph:
            'Ferdi kaza sigortası vefat, yaralanma, sakatlanmaya sebep olan kazalarda geniş bir yelpaze sunmaktadır. ',
          subList: null
        },
        {
          paragraph:
            'Poliçede belirlenen kazalar; iş, ev, trafik kazaları ile beklenmedik olayların yarattığı kazalar güvence altında tutulmaktadır. Bu teminatlar sigortalı tarafından seçilebilmektedir.',
          subList: null
        }
      ]
    }
  },
  getPrice: {
    mainTitle: 'Ferdi Kaza Sigortası Teklifi Nasıl Alınır?',
    campaigns: [
      {
        id: 1,
        name: 'Ferdi Kaza Sigortası',
        assurance: 'Ek Teminatlı',
        price: '+50 TL'
      },
      {
        id: 2,
        name: 'Ferdi Kaza Sigortası',
        assurance: 'Standart Teminatlı',
        price: '+50 TL'
      },
      {
        id: 3,
        name: 'Ferdi Kaza Sigortası',
        assurance: 'Zorunlu Teminatlı',
        price: '+50 TL'
      },
      {
        id: 4,
        name: 'Ferdi Kaza Sigortası',
        assurance: 'Ek Teminatlı',
        price: '+50 TL'
      }
    ]
  },
  faqTitle: 'Türkiye Sigorta Ferdi Kaza Sigortası Hakkında Merak Edilenler',
  faqTitleDesc: 'Her gün yayınlanan güvenilir bilgilere kolay erişim.',
  questions: [
    {
      title: 'Türkiye Sigorta Ferdi Kaza Sigortası Ana Teminatları Nelerdir?',
      content: [
        {
          paragraph:
            'Teminatlar sigortayı oluşturan etmenlerdir. Teminatlar kapsamında poliçe hazırlanır ve geçerli olduğu durumlar belirlenir. ',
          subList: null
        },
        {
          paragraph:
            'Olası her kaza durumu gözetilerek hazırlanmış ana teminatlar şu şekildedir;',
          subList: [
            '<strong>Kaza sonucu vefat teminatı; </strong>kaza sonucunda sigortalı kişinin olay yerinde ya da takip eden 1 yıl içinde vefat etmesi durumunda, yasal mirasçılara ya da sigortalı tarafından önceden belirlenmiş kişilere tazminat ödemesi yapılır.',
            '<strong>Kalıcı maluliyet;</strong> sigortalı kişinin poliçede belirtilen kazalar neticesinde derhal ya da olayı takiben 2 sene içerisinde tam maluliyetinin oluşması durumunda kendisine sigorta limitleri dâhilinde tazminat ödemesi yapılmaktadır. Eğer maluliyet kısmi olursa, yine poliçedeki kısmı maluliyet oranları üzerinden ödeme yapılmaktadır.'
          ]
        }
      ]
    },
    {
      title: 'Türkiye Sigorta Ferdi Kaza Sigortası Ek Teminatları Nelerdir?',
      content: [
        {
          paragraph:
            'Ana teminatların yeterli bulunmadığı durumlarda ek teminatlar ile poliçe kapsamı genişletilmekte ve kazalara bağlı ilave durumları da kapsar hale getirilmektedir. Ek teminatlar kapsamında;',
          subList: [
            'Kaza sonucu tedavi masrafları teminatı; poliçede belirlenen kazanın yaşanması sonucu sigortalı kişinin iyileşmesi için yapılan masraflar teminat altındadır. Poliçede belirtilen limitler dâhilinde tedavi masrafları katılım payına gerek kalmadan karşılanmaktadır.',
            'Gündelik iş görmezlik raporu; kaza sonucu geçici olarak çalışamayacak kişilerin, çalışamadıkları her gün boyunca poliçede belirtilen limit kapsamında ödeme yapılır. Durumu iyileştikçe bu tutar indirilir ve sonunda kesilir. Çalışamama gün sayısı 200 ile sınırlıdır.'
          ]
        }
      ]
    },
    {
      title:
        'Türkiye Sigorta Ferdi Kaza Sigortası Teminat Dışı Durumlar Nelerdir?',
      content: [
        {
          paragraph:
            'Teminat dışı kalan durumlar sigortanın geçersiz olduğu durumları ifade etmektedir. Kaza sayılmayan durumlar teminat dışı tutulmaktadır. ',
          subList: null
        },
        {
          paragraph: 'Teminat dışı sayılan haller ise;',
          subList: [
            'Her türlü grev, lokavt, savaş ya da kitle eylemleri sonucu oluşan hasarlar',
            'Ek bir madde yoksa tüm spor müsabakaları',
            'Hıza bağlı olarak yapılan tehlikeli yarışlar',
            'Yolcu sıfatı dışında gerçekleştirilen hava seyahatleri',
            'İntihar ya da intihara teşebbüs',
            'Alkol, uyuşturucu, ilaç ya da diğer maddelerin kullanımından doğan hasarlar',
            'Nükleer maddelerin sebep olduğu hasarlar',
            'Sigortalı kişinin kasıtlı olarak zarar verecek eylemlerde bulunması'
          ]
        },
        {
          paragraph:
            'Teminat dışı olarak sayılmaktadır. Bu risklerin gerçekleşmesi halinde sigorta herhangi bir ödeme yapmamaktadır.',
          subList: null
        }
      ]
    },
    {
      title:
        'Türkiye Sigorta Ferdi Kaza Sigortası Teminat Bedelleri Nasıl Belirlenir?',
      content: [
        {
          paragraph:
            'Teminat bedellerinin belirlenmesi sigortalı olacak kişinin yaşı ve mesleği temel alarak yapılmaktadır. Bu kriterlerin yanı sıra sigorta süresi, sağlık durumu ve seçilen teminatlar da teminat bedellerini etkilemektedir.',
          subList: null
        }
      ]
    },
    {
      title: 'Türkiye Sigorta Ferdi Kaza Sigortası Güvenceleri Nelerdir?',
      content: [
        {
          paragraph:
            'Ferdi kaza sigortası güvenceleri, olası her kazayı karşılamak üzere oluşturulmuştur. ',
          subList: null
        },
        {
          paragraph:
            'Özellikle trafik, ev ve iş kazaları temel olmak üzere beklenmedik durumlarda yaşanacak kazalara karşı da önlem alınmaktadır. ',
          subList: null
        }
      ]
    },
    {
      title: 'Türkiye Sigorta Ferdi Kaza Sigortası Avantajları Nelerdir?',
      content: [
        {
          paragraph:
            'Kazaların ne zaman olacağı bilinemeyeceği için ferdi kaza sigortası ile pek çok kazaya karşı geniş avantajlar ile kendinizi korumaya alabilirsiniz. ',
          subList: null
        },
        {
          paragraph:
            'Avantajlar teminatlar da belirlendiği gibi ek hizmetler de sigortalı kişiye kullanması için sunulmaktadır. Aynı zamanda sigortalının vefatı halinde tazminatın yakınlarına da ödenebilmesi büyük bir avantaj olarak belirmektedir.',
          subList: null
        }
      ]
    },
    {
      title:
        'Türkiye Sigorta Ferdi Kaza Sigortası İçin Gerekli Bilgiler / Evraklar Nelerdir?',
      content: [
        {
          paragraph:
            'Ferdi kaza sigortası yaptırmak için gereken belge sigortalı olacak kişinin kimlik belgesidir. Kimlik bilgileri ile kısa sürede sigortası yapılmaktadır.',
          subList: null
        }
      ]
    },
    {
      title: 'Türkiye Sigorta Ferdi Kaza Sigortası Zorunlu Mudur?',
      content: [
        {
          paragraph:
            'Zorunlu olmayan ferdi kaza sigortası, yapılması halinde sağladığı faydalar ile kişiye pek çok güvence sunmaktadır. Bu kapsamda yapılması durumunda büyük avantajlar elde edilmektedir. Ayrıca sigortanın sunduğu özel indirimlerden de yararlanılmaktadır.',
          subList: null
        }
      ]
    },
    {
      title: 'Türkiye Sigorta Ferdi Kaza Sigortası Şartları Nelerdir?',
      content: [
        {
          paragraph:
            'Sigortanın ödeme yapması için sigortada belirlenen şartların taşınması gerekir. Bu şartlar genel itibariyle belirtilen yaşlarda olmak, prim ödemelerini düzenli yapmak ve sigorta yükümlülüklerini taşımak olarak belirlenmiştir.',
          subList: null
        }
      ]
    },
    {
      title: 'Türkiye Sigorta Ferdi Kaza Sigortasından Kimler Yararlanabilir?',
      content: [
        {
          paragraph:
            '16 ile 65 yaş aralığında herkes sigortadan yararlanabilirler. ',
          subList: null
        }
      ]
    },
    {
      title:
        'Türkiye Sigorta Ferdi Kaza Sigortasında Yararlanabileceğiniz Hizmetler Nelerdir?',
      content: [
        {
          paragraph:
            'Türkiye Sigorta ferdi kaza sigortası kapsamında teminatların yanı sıra yararlanabileceğiniz hizmetler bulunmaktadır; yol yardımı, acil yardım, anahtar – çilingir hizmeti, tesisat ile ilgili hizmetler, rezervasyon, uçak bileti bulma, kayıp bagajın temin edilmesi, hukuksal danışmanlık gibi konularda yıllık belirlenecek limitler dâhilinde yararlanabilirsiniz.',
          subList: null
        }
      ]
    },
    {
      title: 'Türkiye Sigorta Ferdi Kaza Sigortası Nasıl Yapılır?',
      content: [
        {
          paragraph:
            'Ferdi kaza sigortası yaptırmak için kimlik belgeniz ile başvuruda bulunmanız yeterlidir. ',
          subList: null
        },
        {
          paragraph:
            'Aynı zamanda sigorta durumunuza göre sağlık belgesi vb. belgeler talep edebilir. İstenen bu belgelerin de doğru olarak beyanından sonra tazminat tutarı belirlenir ve seçilen teminatların hesaplaması yapılır. ',
          subList: null
        },
        {
          paragraph:
            'Tüm süreç doğru olarak karşılandığı takdirde kısa sürede poliçe hazır hale gelmektedir.',
          subList: null
        }
      ]
    },
    {
      title:
        'Türkiye Sigorta Ferdi Kaza Sigortasında Vergi İndirimi Var Mıdır?',
      content: [
        {
          paragraph:
            'Ferdi kaza sigortası kapsamında yüzde 15’e varan vergi indirimlerinden yararlanmak mümkündür. Vergi indiriminden yararlanmak için çalışılan firmanın muhasebe birimine poliçeyi göstermek yeterli olacaktır. Hesaplanacak tutar vergi matrahından düşülmektedir.',
          subList: null
        }
      ]
    },
    {
      title:
        'Türkiye Sigorta Ferdi Kaza Sigortasında Dikkat Edilmesi Gerekenler Nelerdir?',
      content: [
        {
          paragraph:
            'Ferdi kaza sigortasının sadece poliçede yer alan kazalarda geçerli olduğuna dikkat edilmelidir. Özellikle hastalık ve hastalığa bağlı durumları karşılamadığına da özen gösterilmelidir. Prim ödemeleri düzenli olarak yapılmalı, karşılaşılacak kazalar, kazadan hemen sonra sigortaya bildirilmelidir.',
          subList: null
        }
      ]
    },
    {
      title: 'Türkiye Sigorta Ferdi Kaza Sigortası Hesaplaması Nasıl Yapılır?',
      content: [
        {
          paragraph:
            'Türkiye Sigorta ferdi kaza sigortası hesaplaması yapmak için seçilen teminatlar ve kişinin yaşı ile mesleği dikkate alınmaktadır. Bu kriterlerin üçü en uygun şekilde hesaplanarak kişiye özel fiyat çıkarılmaktadır. Fiyatın belirlenmesindeki bir diğer husus özellikle yenilemelerde geçerli olan sigortanın ne kadar kullanıldığıdır. ',
          subList: null
        }
      ]
    },
    {
      title:
        'Türkiye Sigorta Ferdi Kaza Sigortası Prim Ödeme Koşulları Nelerdir?',
      content: [
        {
          paragraph:
            'Prim ödemeleri Türk Lirası üzerinden aylık ya da yıllık seçenekler üzerinden ödenmektedir.',
          subList: null
        }
      ]
    },
    {
      title: 'Türkiye Sigorta Ferdi Kaza Sigortası Fiyatları Ne Kadar?',
      content: [
        {
          paragraph:
            'Ferdi kaza sigortası fiyatları, kişiye özel ve yıllık olarak belirlenir. Bu yüzden doğru fiyat için teklif alınması gerekmektedir.',
          subList: null
        }
      ]
    },
    {
      title: 'Türkiye Sigorta Ferdi Kaza Sigortası Fiyat Teklifi Nasıl Alınır?',
      content: [
        {
          paragraph:
            'Fiyat teklifini internet sitesi ve çağrı merkezi üzerinden alabilirsiniz.',
          subList: null
        },
        {
          paragraph:
            'Alokasko uzmanlarından fiyat teklifi alabilmek için 7 gün 24 saat ulaşım sağlayacağınız çağrı merkezi ve internet başvuru formu bulunmaktadır. Sizden istenecek bilgileri doğru olarak girmeniz önemlidir.',
          subList: null
        },
        {
          paragraph:
            'Türkiye Sigorta ferdi kaza sigortası fiyat teklifi almak için internet sitemizden sigorta uzmanlarımıza bilgilerinizi ileterek kolayca fiyat teklifi alabilirsiniz.',
          subList: null
        },
        {
          paragraph:
            '<strong>Ferdi kaza sigortası fiyat teklifi için başvuru formunu doldurmanız yeterlidir.</strong>',
          subList: null
        }
      ]
    }
  ]
}
